module.exports = __webpack_public_path__ + "img/labelsLikesOrderOff.ba8fd61b.svg";